<template>
  <v-container>
    <v-layout row>
      <v-flex xs6>
        <v-select :items="locations" v-model="location" label="Choose a Location" @change="locationEvent"></v-select>
      </v-flex>
      <v-flex xs6>
        <v-select :items="ranges" label="Choose a Date Range" @change="rangeEvent"></v-select>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs6>
        <v-date-picker v-model="startDate" @input="startDateEvent" color="primary"></v-date-picker>
      </v-flex>
      <v-flex xs6>
        <v-date-picker v-model="endDate" @input="endDateEvent" color="primary"></v-date-picker>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'filter-area',
  props: {
    location: null,
    startDate: null,
    endDate: null
  },
  data: () => {
    return {
      locations: [
        { text: 'All', value: 'All' },
        { text: 'Irvine', value: 'Irvine' },
        { text: 'Lake Forest', value: 'Lake Forest' }
      ],
      ranges: [
        { text: 'Daily', value: 'Daily' },
        { text: 'Weekly', value: 'Weekly' },
        { text: 'Monthly', value: 'Monthly' },
        { text: 'Yearly', value: 'Yearly' }
      ]
    }
  },
  methods: {
    locationEvent (val) {
      this.$emit('locationUpdated', val)
    },
    rangeEvent (val) {
      this.$emit('rangeUpdated', val)
    },
    startDateEvent (val) {
      this.$emit('startDateUpdated', val)
    },
    endDateEvent (val) {
      this.$emit('endDateUpdated', val)
    }
  }
}
</script>
